

























































































































































































































































































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DemoServer from "../../shared/DemoServer";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";

import SettingsJson from "../../shared/SettingsJson";
import RentalAccountJson from "../../shared/RentalAccountJson";
import CustomerJson, { defaultCustomerJson } from "../../shared/CustomerJson";
import SepaMandateJson from "../../shared/SepaMandateJson";
import { Gender } from "../../shared/Gender";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateRentalAccountJson, validateRentalAccountJsonAdd } from "../../shared/RentalAccountJson";
import FormSepaMandate from "../general/FormSepaMandate.vue";

export default Vue.extend({
  name: "RentalAccountDetails",
  components: {
    OverlayWindow,
    PointerMenu,
    Loading,
    FormSepaMandate,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    accountId: Number,
    mode: String,
  },
  data() {
    return {
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      Gender: Gender,
      supportsDatePicker: false,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      detailsMode: "",
      settings: null as SettingsJson | null,
      selectedAccountId: null as number | null,
      details: null as RentalAccountJson | null,
      hidePassword: true as boolean,
      password: "" as string,
      useSepaMandate: false as boolean,
      hasChanges: false,
      hintChanged: {
        state: false as boolean,
      },
      toValidate: {} as any,
      validation: null as ValidationResult<RentalAccountJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.initDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    initDetails() {
      this.selectedAccountId = this.accountId;
      this.loadSettings();
      this.loadDetails();

      this.selectDetailsMode(this.mode);
    },

    setCachedData() {
      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadSettings() {
      if (this.restClient != null) {
        this.settings = null;

        try {
          this.settings = await this.restClient.getSettings();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadDetails() {
      if (this.selectedAccountId != null) {
        if (this.restClient != null) {
          try {
            this.details = await this.restClient.getRentalAccount(this.selectedAccountId);

            if (this.details.sepaMandate != null) {
              this.useSepaMandate = true;
            }
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        this.details = this.getDefaultAccountData();
      }

      this.setCachedData();
      this.hasChanges = false;
    },

    getDefaultAccountData() {
      return {
        ID: null,
        type: "",
        customer: this.getDefaultCustomer(),
        sepaMandate: null,
      };
    },

    getDefaultCustomer(): CustomerJson {
      return defaultCustomerJson();
    },

    getDefaultSepaMandate(): SepaMandateJson {
      return {
        ID: null,
        dateTime: new Date().toISOString(),
        lastUseDateTime: new Date().toISOString(),
        accountHolderFirstName: this.details ? this.details.customer.guardianFirstName : "",
        accountHolderLastName: this.details ? this.details.customer.guardianLastName : "",
        addressStreet: this.details ? this.details.customer.addressStreet : "",
        addressZip: this.details ? this.details.customer.addressZip : "",
        addressCity: this.details ? this.details.customer.addressCity : "",
        addressCountry: this.details ? this.details.customer.addressCountry : "",
        IBAN: "",
        BIC: "",
      };
    },

    //START set cached data

    //END set cached data

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Account hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Account bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Account";
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        //todo: use $refs
        document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
        this.selectDetailsMode("show");
        this.hasChanges = false;
        this.loadDetails();
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
          this.selectDetailsMode("show");
          this.hasChanges = false;
          this.loadDetails();
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.details != null) {
        this.validation = validateRentalAccountJson(this.details);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    toggleUseSepaMandate() {
      if (this.details != null) {
        if (this.useSepaMandate) {
          this.details.sepaMandate = null;
          this.useSepaMandate = false;
        } else {
          this.details.sepaMandate = this.getDefaultSepaMandate();
          this.useSepaMandate = true;
        }
      }
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    async addNewAccount() {
      if (this.details != null) {
        this.loadingGeneral = true;
        this.submitValidation = true;

        this.validation = validateRentalAccountJsonAdd(this.details);

        if (this.validation != null && this.validation.isValid == true) {
          try {
            this.details = await this.restClient.addRentalAccount(this.details);
            if (this.details != null) {
              this.selectedAccountId = this.details.ID;
              await this.changePassword();
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.closeDetails();
              alert("Der Account wurde erfolgreich hinzugefügt.");
            }
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Der Account konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveAccountDetails() {
      if (this.details != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;
          this.submitValidation = true;

          if (this.password != "") {
            await this.changePassword();
          }

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateRentalAccountJson(this.details);
          //todo ###END

          if (this.validation != null && this.validation.isValid == true) {
            if (this.restClient != null) {
              try {
                let updatedDetails = await this.restClient.updateRentalAccount(this.details);

                this.hasChanges = false;
                this.loadingGeneral = false;
                this.submitValidation = false;
                this.stopEditMode();

                //TODO: Validation error loest alert auch aus -> prüfen
                alert("Die Änderungen wurden erfolgreich gespeichert.");
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async deleteAccount() {
      if (this.selectedAccountId != null) {
        let c = confirm("Wollen Sie diesen Account wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteRentalAccount(this.selectedAccountId);
              this.closeDetails();
              alert("Der Account wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    async changePassword() {
      if (this.selectedAccountId != null) {
        if (this.restClient != null) {
          try {
            await this.restClient.rentalAccountChangePassword(this.selectedAccountId, this.password);

            this.password = "";
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    details: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
    password: {
      handler() {
        this.hasChanges = true;
      },
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },
  },
});
